export const buildNumber = '20260310.6';
export const version = 'main';
export const latestCommit = 'c4da367c518449bcec58b704b237684c1a23294f';
